import { render } from "./AvenirArea.vue?vue&type=template&id=c7bae81a"
import script from "./AvenirArea.vue?vue&type=script&lang=js"
export * from "./AvenirArea.vue?vue&type=script&lang=js"

import "./AvenirArea.vue?vue&type=style&index=0&id=c7bae81a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__